import { BaseInfo } from './base-info';
import { MemberInfo } from './member-info';

export class TeamInfo extends BaseInfo {

  public name: string;

  public desc?: string;

  public expired_at?: number;

  public user_limit?: number;

  public logo?: string;

  public outside_logo?: string;

  public created_at?: number;

  public created_by?: string;

  public locale?: string;

  public timezone?: string;

  public location?: any;

  public preferences?: any;

  public industry?: string;

  public scale?: number;

  public security?: any;

  public pricing_version?: number;

  public pricing_checkpoints?: any;

  public pricing_setting?: any;

  public is_new?: number;

  public large_mode_enabled?: boolean;

  public is_mission_vnext?: boolean;

  public members?: MemberInfo[];

  public member_count?: number;

  public services?: any[];

  public apps?: any[];

  public privileges?: any;

  public checkpoints?: string;

  public modules?: any;

  public allowPostGeneral?: Boolean;

  public href?: string;

  public team_permission?: any;

  public domain?: string;

}
